const apiDomain =
  "https://om352u371e.execute-api.ap-southeast-1.amazonaws.com/dev/api";
// const apiDomain = "http://localhost:5000/api";

export const config = {
  apiDomain: apiDomain,
  services: {
    global: {
      getEvent: apiDomain + "/event",
    },
    user: {
      create: apiDomain + "/user/create",
      login: apiDomain + "/user/login",
      getProfile: apiDomain + "/user",
      updateProfile: apiDomain + "/user",
    },
    event: {
      createEvent: apiDomain + "/event",
      editEvent: apiDomain + "/event/",
      deleteEventByID: apiDomain + "/event/",
      getEventById: apiDomain + "/event/",
      scanQR: apiDomain + "/registration/scan",
      changeAttendance: apiDomain + "/registration/attend",
      registration: apiDomain + "/registration/event",
      getInbox: apiDomain + "/registration/inbox",
      getInboxByID: apiDomain + "/registration/inbox/",
      getEventParticipantById: apiDomain + "/registration/participant/",
    },
  },
};
